import scripture from "./../../img/Israel/Scripture_Readings_Israel_Tour.pdf";
import styles from "../../Styles/ScriptureGuide.module.scss";
import { useState } from "react";
import { useParams } from "react-router-dom";

function Scriptureguide() {
  const params = useParams();
  const readingExample = [
    {
      day: "Day 3",
      content: [
        {
          place: "Caesarea:",
          text: "Acts 10, Acts 12:18-25, Acts 8:40, 21:8, Acts 23:23 to end of chapter 26; Beck pp 108-111"
        },
        {
          place: "Mt. Carmel:",
          text: "I Kings 18:17-46, II Kings 4:25; Beck pp 220-222"
        },
        {
          place: "Jezreel Valley & Megiddo:",
          text: "I Kings 9:15, II Kings 9:27 (II King 9), II Chronicles 35:20-25, II Kings 23:29-30; Beck 211-215"
        },
        {
          place: "Tiberias:",
          text: "for information go to the following link on Bible Walks."
        }
      ],
      link: []
    },
    {
      day: "Day 4",
      content: [
        {
          place: "Harod's Spring:",
          text: "Judges 7; Beck 193-195"
        },
        {
          place: "Nazareth Brow and Village:",
          text: "Luke 1:26-38, Luke 2:39-52, Luke 4:14-31, Luke 7:11-17 (Nain); Beck 224-227"
        }
      ],
      link: []
    },
    {
      day: "Day 5",
      content: [
        {
          place: "Mt. Arbel:",
          text: "Matthew 4:12-23, Luke 8:1-3; Beck 215-218"
        },
        {
          place: "Sea of Galilee:",
          text: "Matthew 4:18-22, Matthew 8:23-27 (calming the sea) Matthew 14:22-36 (walking on water), Luke 5:1-11 (fishers of men), John 21:1-14 (post resurrection appearance); Beck 227-230"
        },
        {
          place: "Capernaum:",
          text: " Mark 1:21-35, (demoniac healed and Peter’s mother in law),n Mark 2:1-5 (paralyzed man let down through the roof); Beck 185-189"
        },
        {
          place: "Mt. of Beatitudes:",
          text: "Matthew 5-7, Luke 6:12, John 6:15; Beck 218-219"
        },
        { place: "Kursi (Gergesa):", text: "Mark 5:1-20; Beck 209-211" },
        {
          place: "Hippos/Sussita (Decapolis):",
          text: " Mark 5:20, Matthew 5:14-15"
        }
      ],
      link: []
    },
    {
      day: "Day 6",
      content: [
        {
          place: "Dan:",
          text: "II Samuel 24:2 (Dan to Beersheba), Genesis 14:13-16, Judges 18:27-29, I Kings 12:26-33; Beck 189-193"
        },
        {
          place: "Caesarea Philippi:",
          text: "Matthew 16:13-18; Beck 179-181"
        },
        {
          place: "Mt Hermon:",
          text: "Matthew 17:1-8, Psalm 133; Beck"
        }
      ],
      link: [
        {
          place: "valley of Tears",
          name: "Israel Inside Out",
          reference: {
            href: "https://israelinsideout.com/galilee-and-golan/the-valley-of-tears.html",
            target: "_blank"
          }
        }
      ]
    },
    {
      day: "Day 7",
      content: [
        {
          place: "Jordan River:",
          text: "Matthew 3:13-17 (baptism of Jesus), Joshua 3 (crossing of the Jordan), II Kings 5:13-14 (healing of Naaman)"
        },
        {
          place: "Qumran:",
          text: "Beck 153-155"
        },

        {
          place: "The Dead Sea:",
          text: "Beck 126-127"
        }
      ],
      link: []
    },
    {
      day: "Day 8",
      content: [
        {
          place: "Ein Gedi:",
          text: "I Samuel 23:29-I Samuel 24; Beck 131-132"
        },
        {
          place: "Jerusalem:",
          text: "Beck 41-44"
        },

        {
          place: "The Broad Wall:",
          text: "II Chronicles 32:1-5; Beck 48-49"
        },
        {
          place: "Western Wall:",
          text: "Beck 81-84"
        },

        {
          place: "Church of the Holy Sepulcher: ",
          text: "Beck 51-54"
        }
      ],
      link: []
    },
    {
      day: "Day 9",
      content: [
        {
          place: "The Temple Mount: ",
          text: "Genesis 22:9-14 (Abraham offers Isaac), II Samuel 24 :18-25 (David buys the ground for the Temple), 2 Chronicles 3:1 (Solomon builds the first temple), John 2 :13-16 (Herod’s temple that Jesus cleansed) ; Beck 73-76"
        },
        {
          place: "Pool of Bethesda:",
          text: "John 5:1-9; Beck 46-47"
        },

        {
          place: "Mt Zion (Tomb of David and The Upper Room):",
          text: "Mark 14:13-26, John 13-17; Beck 77-79"
        },
        {
          place: "Valley of Gehenna (Hinnom) and Akeldama:",
          text: "I Chronicles 33:1-6 (Manasseh), Matthew 5:30, 10:28 (hell/Gehenna), Matthew 27:1-10 (Judas and the field of blood); Beck 44-46"
        },

        {
          place: "City of David:",
          text: "2 Samuel 5:6-10 (David conquers the city), 2 Samuel 11:2-4; Beck 55-62"
        },
        {
          place: "Hezekiah’s Tunnel/Pool of Siloam:",
          text: "II Chronicles 32:30 (Hezekiah digs the tunnel), John 9:1-11 (Healing of the man born blind) , II Kings 18-19 (story of Hezekiah and Sennacherib); Beck 60-61"
        }
      ],
      link: []
    },
    {
      day: "Day 10",
      content: [
        {
          place: "Mt. of Olives:",
          text: "Mark 11:1-25 (cursing of the fig tree and teaching on prayer), Luke 19:41-44 (Jesus wept over the city). Matthew 24-25 (the Olivet Discourse), Luke 24:50-53, Acts 1:9-12 (the ascension of Jesus), Zechariah 14:2-8; Beck 94-101"
        },
        {
          place: "Gethsemane:",
          text: "Matthew 26:36-57, Luke 22:39-54, John 18:1; Beck 95-96"
        },

        {
          place: "Kidron Valley:",
          text: "II Chronicles 24:20-25 (Zechariah’s Tomb); Beck 68-70"
        },
        {
          place: "Gordon’s Calvary/ the Garden Tomb:",
          text: "John 19:16-18, 38-42; Beck 63-64"
        },

        {
          place: "Church of the Holy Sepulchre:",
          text: "Beck 51-54"
        }
      ],
      link: []
    },
    {
      day: "Day 11",
      content: [
        {
          place: "Bethlehem: ",
          text: "Genesis 35:16-20 (Rachel’s tomb), book of Ruth (Boaz and Ruth), 1 Samuel 16:1-13, 17:12 (hometown of David; he is anointed here) Micah 5:2, (Prophecy that Messiah will be born here) Luke 2:1-14 (Jesus is born here; Shepherds visit the infant Jesus), Matthew 2:1-12 (The wise men visit here); Beck 87-90"
        },
        { place: "Valley of Elah:", text: " I Samuel 17; Beck 127-129" },
        {
          place: "Joppa/Jaffa:",
          text: "Jonah 1:3, Acts 9:36-43, Acts 10, II Chronicles 2:16; Beck 112-113"
        }
      ],
      link: []
    },
    {
      day: "Day 12",
      content: [
        {
          place: "The Red Sea and Eilat:",
          text: "Exodus 14, I Kings 9:26 (place where Solomon built ships)."
        }
      ],
      link: []
    },
    {
      day: "Day 13",
      content: [
        {
          place: "",
          text: "Galatians 1:13-17; II Corinthians 11:32-33"
        }
      ],
      link: [
        {
          place: "Petra",
          name: "Wikipedia - PetraLonely Planet - Petra",
          reference: {
            href: "https://en.wikipedia.org/wiki/Petra",
            target: "_blank"
          }
        },
        {
          place: "",
          name: "Wikipedia - PetraLonely Planet - Petra",
          reference: {
            href: "https://www.lonelyplanet.com/jordan/petra/attractions/petra/a/poi-sig/1457302/1001785",
            target: "_blank"
          }
        },
        {
          place: "Was the Apostle Paul at Petra?",
          name: "Biblical Archaeology",
          reference: {
            href: "https://www.biblicalarchaeology.org/daily/the-apostle-paul-in-arabia/",
            target: "_blank"
          }
        }
      ]
    },
    {
      day: "Day 14",
      content: [
        {
          place: "Timna Park/replica of the Tabernacle:",
          text: "Exodus 25-30; Beck 156-157"
        },
        {
          place: "Beersheba: ",
          text: "Genesis 21:22-34; 26:23-33; Beck 119-122"
        }
      ],
      link: []
    }
  ];

  const readingSeptember = [
    {
      day: "Day 3, October 1",
      content: [
        {
          place: "Caesarea:",
          text: "Acts 10, Acts 12:18-25, Acts 8:40, 21:8, Acts 23:23 to end of chapter 26; Beck pp 108-111"
        },
        {
          place: "Mt. Carmel:",
          text: "I Kings 18:17-46, II Kings 4:25; Beck pp 220-222"
        },
        {
          place: "Jezreel Valley & Megiddo:",
          text: "I Kings 9:15, II Kings 9:27 (II King 9), II Chronicles 35:20-25, II Kings 23:29-30; Beck 211-215"
        },
        {
          place: "Tiberias:",
          text: "for information go to the following link on Bible Walks."
        }
      ],
      link: [
        {
          place: "Tiberias:",
          name: "Bible Walks",
          reference: {
            href: "https://www.biblewalks.com/Tiberias/",
            target: "_blank"
          }
        }
      ]
    },
    {
      day: "Day 4, October 2",
      content: [
        {
          place: "Harod's Spring:",
          text: "Judges 7; Beck 193-195"
        },
        {
          place: "Nazareth Brow and Village:",
          text: "Luke 1:26-38, Luke 2:39-52, Luke 4:14-31, Luke 7:11-17 (Nain); Beck 224-227"
        }
      ],
      link: []
    },
    {
      day: "Day 5, October 3",
      content: [
        {
          place: "Mt. Arbel:",
          text: "Matthew 4:12-23, Luke 8:1-3; Beck 215-218"
        },
        {
          place: "Sea of Galilee:",
          text: "Matthew 4:18-22, Matthew 8:23-27 (calming the sea) Matthew 14:22-36 (walking on water), Luke 5:1-11 (fishers of men), John 21:1-14 (post resurrection appearance); Beck 227-230"
        },
        {
          place: "Capernaum:",
          text: " Mark 1:21-35, (demoniac healed and Peter’s mother in law),n Mark 2:1-5 (paralyzed man let down through the roof); Beck 185-189"
        },
        {
          place: "Mt. of Beatitudes:",
          text: "Matthew 5-7, Luke 6:12, John 6:15; Beck 218-219"
        },
        { place: "Kursi (Gergesa):", text: "Mark 5:1-20; Beck 209-211" },
        {
          place: "Hippos/Sussita (Decapolis):",
          text: " Mark 5:20, Matthew 5:14-15"
        }
      ],
      link: []
    },
    {
      day: "Day 6, October 4",
      content: [
        {
          place: "Dan:",
          text: "II Samuel 24:2 (Dan to Beersheba), Genesis 14:13-16, Judges 18:27-29, I Kings 12:26-33; Beck 189-193"
        },
        {
          place: "Caesarea Philippi:",
          text: "Matthew 16:13-18; Beck 179-181"
        },
        {
          place: "Mt Hermon:",
          text: "Matthew 17:1-8, Psalm 133; Beck"
        }
      ],
      link: []
    },
    {
      day: "Day 7, October 5",
      content: [
        {
          place: "Jordan River:",
          text: "Matthew 3:13-17 (baptism of Jesus), Joshua 3 (crossing of the Jordan), II Kings 5:13-14 (healing of Naaman)"
        },
        {
          place: "Qumran:",
          text: "Beck 153-155"
        },

        {
          place: "The Dead Sea:",
          text: "Beck 126-127"
        }
      ],
      link: []
    },
    {
      day: "Day 8, October 6",
      content: [
        {
          place: "Ein Gedi:",
          text: "I Samuel 23:29-I Samuel 24; Beck 131-132"
        },
        {
          place: "Jerusalem:",
          text: "Beck 41-44"
        },

        {
          place: "The Broad Wall:",
          text: "II Chronicles 32:1-5; Beck 48-49"
        },
        {
          place: "Western Wall:",
          text: "Beck 81-84"
        },

        {
          place: "Church of the Holy Sepulcher: ",
          text: "Beck 51-54"
        }
      ],
      link: []
    },
    {
      day: "Day 9, October 7",
      content: [
        {
          place: "The Temple Mount: ",
          text: "Genesis 22:9-14 (Abraham offers Isaac), II Samuel 24 :18-25 (David buys the ground for the Temple), 2 Chronicles 3:1 (Solomon builds the first temple), John 2 :13-16 (Herod’s temple that Jesus cleansed) ; Beck 73-76"
        },
        {
          place: "Pool of Bethesda:",
          text: "John 5:1-9; Beck 46-47"
        },

        {
          place: "Mt Zion (Tomb of David and The Upper Room):",
          text: "Mark 14:13-26, John 13-17; Beck 77-79"
        },
        {
          place: "Valley of Gehenna (Hinnom) and Akeldama:",
          text: "I Chronicles 33:1-6 (Manasseh), Matthew 5:30, 10:28 (hell/Gehenna), Matthew 27:1-10 (Judas and the field of blood); Beck 44-46"
        },

        {
          place: "City of David:",
          text: "2 Samuel 5:6-10 (David conquers the city), 2 Samuel 11:2-4; Beck 55-62"
        },
        {
          place: "Hezekiah’s Tunnel/Pool of Siloam:",
          text: "II Chronicles 32:30 (Hezekiah digs the tunnel), John 9:1-11 (Healing of the man born blind) , II Kings 18-19 (story of Hezekiah and Sennacherib); Beck 60-61"
        }
      ],
      link: []
    },
    {
      day: "Day 10, October 8",
      content: [
        {
          place: "Mt. of Olives:",
          text: "Mark 11:1-25 (cursing of the fig tree and teaching on prayer), Luke 19:41-44 (Jesus wept over the city). Matthew 24-25 (the Olivet Discourse), Luke 24:50-53, Acts 1:9-12 (the ascension of Jesus), Zechariah 14:2-8; Beck 94-101"
        },
        {
          place: "Gethsemane:",
          text: "Matthew 26:36-57, Luke 22:39-54, John 18:1; Beck 95-96"
        },

        {
          place: "Kidron Valley:",
          text: "II Chronicles 24:20-25 (Zechariah’s Tomb); Beck 68-70"
        },
        {
          place: "Gordon’s Calvary/ the Garden Tomb:",
          text: "John 19:16-18, 38-42; Beck 63-64"
        }
      ],
      link: []
    },
    {
      day: "Day 11, October 9",
      content: [
        {
          place: "Bethlehem: ",
          text: "Genesis 35:16-20 (Rachel’s tomb), book of Ruth (Boaz and Ruth), 1 Samuel 16:1-13, 17:12 (hometown of David; he is anointed here) Micah 5:2, (Prophecy that Messiah will be born here) Luke 2:1-14 (Jesus is born here; Shepherds visit the infant Jesus), Matthew 2:1-12 (The wise men visit here); Beck 87-90"
        },
        { place: "Valley of Elah:", text: " I Samuel 17; Beck 127-129" },
        {
          place: "Joppa/Jaffa:",
          text: "Jonah 1:3, Acts 9:36-43, Acts 10, II Chronicles 2:16; Beck 112-113"
        }
      ],
      link: []
    },
    {
      day: "Day 12, October 10",
      content: [
        {
          place: "The Red Sea and Eilat:",
          text: "Exodus 14, I Kings 9:26 (place where Solomon built ships)."
        }
      ],
      link: []
    },
    {
      day: "Day 13, October 11",
      content: [
        {
          place: "Petra:",
          text: "Galatians 1:13-17; II Corinthians 11:32-33"
        }
      ],
      link: [
        {
          place: "Petra:",
          name: "Wikipedia - Petra",
          reference: {
            href: "https://en.wikipedia.org/wiki/Petra",
            target: "_blank"
          }
        },
        {
          place: "",
          name: "Lonely Planet - Petra",
          reference: {
            href: "https://www.lonelyplanet.com/jordan/petra/attractions/petra/a/poi-sig/1457302/1001785",
            target: "_blank"
          }
        },
        {
          place: "",
          name: "Was the Apostle Paul at Petra? Biblical Archaeology",
          reference: {
            href: "https://www.biblicalarchaeology.org/daily/the-apostle-paul-in-arabia/",
            target: "_blank"
          }
        }
      ]
    },
    {
      day: "Day 14, October 12",
      content: [
        {
          place: "Timna Park/replica of the Tabernacle:",
          text: "Exodus 25-30; Beck 156-157"
        },
        {
          place: "Beersheba: ",
          text: "Genesis 21:22-34; 26:23-33; Beck 119-122"
        }
      ],
      link: []
    }
  ];

  const readingOctober = [
    {
      day: "Day 3, October 22",
      content: [
        {
          place: "Caesarea:",
          text: "Acts 10, Acts 12:18-25, Acts 8:40, 21:8, Acts 23:23 to end of chapter 26; Beck pp 108-111"
        },
        {
          place: "Mt. Carmel:",
          text: "I Kings 18:17-46, II Kings 4:25; Beck pp 220-222"
        },
        {
          place: "Jezreel Valley & Megiddo:",
          text: "I Kings 9:15, II Kings 9:27 (II King 9), II Chronicles 35:20-25, II Kings 23:29-30; Beck 211-215"
        },
        {
          place: "Nazareth Brow and Village:",
          text: " Luke 1:26-38, Luke 2:39-52, Luke 4:14-31, Luke 7:11-17 (Nain); Beck 224-227"
        },
        {
          place: "Tiberias:",
          text: "for information go to the following link on Bible Walks."
        }
      ],
      link: [
        {
          place: "Tiberias:",
          name: "Bible Walks",
          reference: {
            href: "https://www.biblewalks.com/Tiberias/",
            target: "_blank"
          }
        }
      ]
    },
    {
      day: "Day 4, October 23",
      content: [
        {
          place: "Mt. Arbel: ",
          text: "JMatthew 4:12-23, Luke 8:1-3; Beck 215-218"
        },
        {
          place: "Sea of Galilee:",
          text: "Matthew 4:18-22, Matthew 8:23-27 (calming the sea) Matthew 14:22-36 (walking on water), Luke 5:1-11 (fishers of men), John 21:1-14 (post resurrection appearance); Beck 227-230"
        },
        {
          place: "Capernaum:",
          text: "Mark 1:21-35, (demoniac healed and Peter’s mother in law),n Mark 2:1-5 (paralyzed man let down through the roof); Beck 185-189"
        },
        {
          place: "Mt. of Beatitudes:",
          text: "Matthew 5-7, Luke 6:12, John 6:15; Beck 218-219"
        },
        {
          place: "Kursi (Gergesa):",
          text: " Mark 5:1-20; Beck 209-211"
        },
        {
          place: "Hippos/Sussita (Decapolis):",
          text: "Mark 5:20, Matthew 5:14-15"
        }
      ],
      link: []
    },
    {
      day: "Day 5, October 24",
      content: [
        {
          place: "Dan:",
          text: "II Samuel 24:2 (Dan to Beersheba), Genesis 14:13-16, Judges 18:27-29, I Kings 12:26-33; Beck 189-193"
        },
        {
          place: "Caesarea Philippi:",
          text: "Matthew 16:13-18; Beck 179-181"
        },
        { place: "Mt Hermon:", text: "Matthew 17:1-8, Psalm 133; Beck" }
      ],
      link: []
    },
    {
      day: "Day 6, October 25",
      content: [
        {
          place: "Jordan River:",
          text: "Matthew 3:13-17 (baptism of Jesus), Joshua 3 (crossing of the Jordan), II Kings 5:13-14 (healing of Naaman)"
        },
        {
          place: "Qumran:",
          text: "Beck 153-155"
        },
        {
          place: "Masada:",
          text: "Beck 149-152"
        },
        {
          place: "The Dead Sea: ",
          text: "Beck 126-127"
        }
      ],
      link: []
    },
    {
      day: "Day 7, October 26",
      content: [
        {
          place: "Ein Gedi:",
          text: "Beck 131-132"
        },
        {
          place: "Jerusalem:",
          text: "Beck 41-44"
        },

        {
          place: "The Broad Wall:",
          text: "II Chronicles 32:1-5; Beck 48-49"
        },
        {
          place: "Western Wall:",
          text: "Beck 81-84"
        },
        { place: "Church of the Holy Sepulcher:", text: "Beck 51-54" }
      ],
      link: []
    },
    {
      day: "Day 8, October 27",
      content: [
        {
          place: "Mt. of Olives:",
          text: "Mark 11:1-25 (cursing of the fig tree and teaching on prayer), Luke 19:41-44 (Jesus wept over the city). Matthew 24-25 (the Olivet Discourse), Luke 24:50-53, Acts 1:9-12 (the ascension of Jesus), Zechariah 14:2-8; Beck 94-101"
        },
        {
          place: "Gethsemane:",
          text: "Matthew 26:36-57, Luke 22:39-54, John 18:1; Beck 95-96"
        },
        {
          place: "Kidron Valley:",
          text: "II Chronicles 24:20-25 (Zechariah’s Tomb); Beck 68-70"
        },

        {
          place: "Gordon’s Calvary/ the Garden Tomb: ",
          text: "John 19:16-18, 38-42; Beck 63-64"
        }
      ],
      link: []
    },
    {
      day: "Day 9, October 28",
      content: [
        {
          place: "The Temple Mount: ",
          text: "Genesis 22:9-14 (Abraham offers Isaac), II Samuel 24 :18-25 (David buys the ground for the Temple), 2 Chronicles 3:1 (Solomon builds the first temple), John 2 :13-16 (Herod’s temple that Jesus cleansed) ; Beck 73-76"
        },
        {
          place: "Pool of Bethesda:",
          text: "John 5:1-9; Beck 46-47"
        },
        {
          place: "City of David:",
          text: "2 Samuel 5:6-10 (David conquers the city), 2 Samuel 11:2-4; Beck 55-62"
        },

        {
          place: "Hezekiah’s Tunnel/Pool of Siloam:",
          text: "II Chronicles 32:30 (Hezekiah digs the tunnel), John 9:1-11 (Healing of the man born blind) , II Kings 18-19 (story of Hezekiah and Sennacherib); Beck 60-61"
        },
        {
          place: "Mt Zion (Tomb of David and The Upper Room):",
          text: "Mark 14:13-26, John 13-17; Beck 77-79"
        },
        {
          place: "Valley of Gehenna (Hinnom) and Akeldama:",
          text: "I Chronicles 33:1-6 (Manasseh), Matthew 5:30, 10:28 (hell/Gehenna), Matthew 27:1-10 (Judas and the field of blood); Beck 44-46"
        }
      ],
      link: []
    },
    {
      day: "Day 10, October 29",
      content: [
        {
          place: "Bethlehem:",
          text: " Genesis 35:16-20 (Rachel’s tomb), book of Ruth (Boaz and Ruth), 1 Samuel 16:1-13, 17:12 (hometown of David; he is anointed here) Micah 5:2, (Prophecy that Messiah will be born here) Luke 2:1-14 (Jesus is born here; Shepherds visit the infant Jesus), Matthew 2:1-12 (The wise men visit here); Beck 87-90"
        },
        {
          place: "Valley of Elah:",
          text: "I Samuel 17; Beck 127-129"
        },

        {
          place: "Joppa/Jaffa:",
          text: "Jonah 1:3, Acts 9:36-43, Acts 10, II Chronicles 2:16; Beck 112-113"
        }
      ],
      link: []
    }
  ];

  // READING NOVEMBER
  const readingNovember = [
    {
      day: "Day 3, November 4",
      content: [
        {
          place: "Caesarea:",
          text: "Acts 10, Acts 12:18-25, Acts 8:40, 21:8, Acts 23:23 to end of chapter 26; Beck pp 108-111"
        },
        {
          place: "Mt. Carmel:",
          text: "I Kings 18:17-46, II Kings 4:25; Beck pp 220-222"
        },
        {
          place: "Jezreel Valley & Megiddo:",
          text: "I Kings 9:15, II Kings 9:27 (II King 9), II Chronicles 35:20-25, II Kings 23:29-30; Beck 211-215"
        },
        {
          place: "Tiberias:",
          text: "for information go to the following link on Bible Walks."
        }
      ],
      link: [
        {
          place: "Tiberias:",
          name: "Bible Walks",
          reference: {
            href: "https://www.biblewalks.com/Tiberias/",
            target: "_blank"
          }
        }
      ]
    },
    {
      day: "Day 4, November 5",
      content: [
        {
          place: "Harod's Spring:",
          text: "Judges 7; Beck 193-195"
        },
        {
          place: "Nazareth Brow and Village:",
          text: "Luke 1:26-38, Luke 2:39-52, Luke 4:14-31, Luke 7:11-17 (Nain); Beck 224-227"
        }
      ],
      link: []
    },
    {
      day: "Day 5, November 6",
      content: [
        {
          place: "Mt. Arbel:",
          text: "Matthew 4:12-23, Luke 8:1-3; Beck 215-218"
        },
        {
          place: "Sea of Galilee:",
          text: "Matthew 4:18-22, Matthew 8:23-27 (calming the sea) Matthew 14:22-36 (walking on water), Luke 5:1-11 (fishers of men), John 21:1-14 (post resurrection appearance); Beck 227-230"
        },
        {
          place: "Capernaum:",
          text: " Mark 1:21-35, (demoniac healed and Peter’s mother in law),n Mark 2:1-5 (paralyzed man let down through the roof); Beck 185-189"
        },
        {
          place: "Mt. of Beatitudes:",
          text: "Matthew 5-7, Luke 6:12, John 6:15; Beck 218-219"
        },
        { place: "Kursi (Gergesa):", text: "Mark 5:1-20; Beck 209-211" },
        {
          place: "Hippos/Sussita (Decapolis):",
          text: " Mark 5:20, Matthew 5:14-15"
        }
      ],
      link: []
    },
    {
      day: "Day 6, November 7",
      content: [
        {
          place: "Dan:",
          text: "II Samuel 24:2 (Dan to Beersheba), Genesis 14:13-16, Judges 18:27-29, I Kings 12:26-33; Beck 189-193"
        },
        {
          place: "Caesarea Philippi:",
          text: "Matthew 16:13-18; Beck 179-181"
        },
        {
          place: "Mt Hermon:",
          text: "Matthew 17:1-8, Psalm 133; Beck"
        }
      ],
      link: []
    },
    {
      day: "Day 7, November 8",
      content: [
        {
          place: "Jordan River:",
          text: "Matthew 3:13-17 (baptism of Jesus), Joshua 3 (crossing of the Jordan), II Kings 5:13-14 (healing of Naaman)"
        },
        {
          place: "Qumran:",
          text: "Beck 153-155"
        },

        {
          place: "The Dead Sea:",
          text: "Beck 126-127"
        }
      ],
      link: []
    },
    {
      day: "Day 8, November 9",
      content: [
        {
          place: "Ein Gedi:",
          text: "I Samuel 23:29-I Samuel 24; Beck 131-132"
        },
        {
          place: "Jerusalem:",
          text: "Beck 41-44"
        },

        {
          place: "The Broad Wall:",
          text: "II Chronicles 32:1-5; Beck 48-49"
        },
        {
          place: "Western Wall:",
          text: "Beck 81-84"
        },

        {
          place: "Church of the Holy Sepulcher: ",
          text: "Beck 51-54"
        }
      ],
      link: []
    },
    {
      day: "Day 9, November 10",
      content: [
        {
          place: "The Temple Mount: ",
          text: "Genesis 22:9-14 (Abraham offers Isaac), II Samuel 24 :18-25 (David buys the ground for the Temple), 2 Chronicles 3:1 (Solomon builds the first temple), John 2 :13-16 (Herod’s temple that Jesus cleansed) ; Beck 73-76"
        },
        {
          place: "Pool of Bethesda:",
          text: "John 5:1-9; Beck 46-47"
        },

        {
          place: "Mt Zion (Tomb of David and The Upper Room):",
          text: "Mark 14:13-26, John 13-17; Beck 77-79"
        },
        {
          place: "Valley of Gehenna (Hinnom) and Akeldama:",
          text: "I Chronicles 33:1-6 (Manasseh), Matthew 5:30, 10:28 (hell/Gehenna), Matthew 27:1-10 (Judas and the field of blood); Beck 44-46"
        },

        {
          place: "City of David:",
          text: "2 Samuel 5:6-10 (David conquers the city), 2 Samuel 11:2-4; Beck 55-62"
        },
        {
          place: "Hezekiah’s Tunnel/Pool of Siloam:",
          text: "II Chronicles 32:30 (Hezekiah digs the tunnel), John 9:1-11 (Healing of the man born blind) , II Kings 18-19 (story of Hezekiah and Sennacherib); Beck 60-61"
        }
      ],
      link: []
    },
    {
      day: "Day 10, November 11",
      content: [
        {
          place: "Mt. of Olives:",
          text: "Mark 11:1-25 (cursing of the fig tree and teaching on prayer), Luke 19:41-44 (Jesus wept over the city). Matthew 24-25 (the Olivet Discourse), Luke 24:50-53, Acts 1:9-12 (the ascension of Jesus), Zechariah 14:2-8; Beck 94-101"
        },
        {
          place: "Gethsemane:",
          text: "Matthew 26:36-57, Luke 22:39-54, John 18:1; Beck 95-96"
        },

        {
          place: "Kidron Valley:",
          text: "II Chronicles 24:20-25 (Zechariah’s Tomb); Beck 68-70"
        },
        {
          place: "Gordon’s Calvary/ the Garden Tomb:",
          text: "John 19:16-18, 38-42; Beck 63-64"
        }
      ],
      link: []
    },
    {
      day: "Day 11, November 12",
      content: [
        {
          place: "Bethlehem: ",
          text: "Genesis 35:16-20 (Rachel’s tomb), book of Ruth (Boaz and Ruth), 1 Samuel 16:1-13, 17:12 (hometown of David; he is anointed here) Micah 5:2, (Prophecy that Messiah will be born here) Luke 2:1-14 (Jesus is born here; Shepherds visit the infant Jesus), Matthew 2:1-12 (The wise men visit here); Beck 87-90"
        },
        { place: "Valley of Elah:", text: " I Samuel 17; Beck 127-129" },
        {
          place: "Joppa/Jaffa:",
          text: "Jonah 1:3, Acts 9:36-43, Acts 10, II Chronicles 2:16; Beck 112-113"
        }
      ],
      link: []
    },
    {
      day: "Day 12, November 13",
      content: [
        {
          place: "The Red Sea and Eilat:",
          text: "Exodus 14, I Kings 9:26 (place where Solomon built ships)."
        }
      ],
      link: []
    },
    {
      day: "Day 13, November 14",
      content: [
        {
          place: "Petra:",
          text: "Galatians 1:13-17; II Corinthians 11:32-33"
        }
      ],
      link: [
        {
          place: "Petra:",
          name: "Wikipedia - Petra",
          reference: {
            href: "https://en.wikipedia.org/wiki/Petra",
            target: "_blank"
          }
        },
        {
          place: "",
          name: "Lonely Planet - Petra",
          reference: {
            href: "https://www.lonelyplanet.com/jordan/petra/attractions/petra/a/poi-sig/1457302/1001785",
            target: "_blank"
          }
        },
        {
          place: "",
          name: "Was the Apostle Paul at Petra? Biblical Archaeology",
          reference: {
            href: "https://www.biblicalarchaeology.org/daily/the-apostle-paul-in-arabia/",
            target: "_blank"
          }
        }
      ]
    },
    {
      day: "Day 14, November 15",
      content: [
        {
          place: "Timna Park/replica of the Tabernacle:",
          text: "Exodus 25-30; Beck 156-157"
        },
        {
          place: "Beersheba: ",
          text: "Genesis 21:22-34; 26:23-33; Beck 119-122"
        }
      ],
      link: []
    }
  ];

  const [visiable, setVisiable] = useState([
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false
  ]);

  const changeVisiable = (day) => {
    const newVis = visiable.map((el, i) => {
      if (i === day) {
        return (el = true);
      } else {
        return (el = false);
      }
    });
    setVisiable(newVis);
  };

  let reading = [];
  switch (params.trip) {
    case "September-2026":
      reading = readingSeptember;
      break;
    case "October-2026":
      reading = readingOctober;

      break;
    case "November-2026":
      reading = readingNovember;
      break;
    case "trip":
      reading = readingExample;
      break;
  }
  return (
    <div className="pageContainer">
      <div className="title">Scripture Reading</div>
      <p className="secondaryTitle">Israel Tour</p>
      {/* <div className="printBox">
        <div className="print">
          <a href={scripture} target="_blank" rel="noreferrer">
            Print PDF
          </a>
        </div>
      </div> */}
      <p className="text">
        This is a reading guide from the Bible and the recommended handbook. It
        corresponds with the itinerary.
      </p>

      <div className={styles.bookSection}>
        <p className={styles.book}>The Bible</p>
        <p className={styles.book}>
          The Holy Land for Christian Travelers: An Illustrated Guide to Israel,
          <span className={styles.bookOther}>
            John A. Beck. Baker Books, 2017. Available on Amazon for $16.99
            (paper) and $9.99 (kindle). Gives lots of information about the
            sites.
          </span>{" "}
          <span className={styles.bookComment}>
            (This book is highly recommended for understanding the sites in
            Israel.)
          </span>
        </p>
      </div>

      <div className={styles.readingDates}>
        {reading.map((el, i) => (
          <p
            key={i}
            className={styles.paragraphTitle}
            style={{
              color: visiable[reading.indexOf(el)] ? "orange" : ""
            }}
            onClick={() => changeVisiable(i)}
          >
            {el.day}
          </p>
        ))}
      </div>
      <div>
        {reading.map((item, i) => (
          <div key={i}>
            {visiable[i] ? (
              <div className={styles.readingBox}>
                <p className={styles.readingComment}>{reading[i].day}</p>
                {item.content.map((par, i) => (
                  <p className="text" key={i}>
                    {" "}
                    <span className={styles.city}>{par.place}</span> {par.text}
                  </p>
                ))}
                {item.link.map((par, i) => (
                  <p key={i}>
                    <a
                      {...par.reference}
                      rel="norferrer"
                      className={styles.link}
                    >
                      {par.name}
                    </a>
                  </p>
                ))}
              </div>
            ) : (
              ""
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Scriptureguide;
